module.exports = __webpack_public_path__ + "img/图1-4  自动驾驶汽车.ee1e3caf.jpeg";